import _ from "lodash";
import { bindActionCreators } from "redux";

export default (actions) => (dispatch) =>
  _.mapValues(actions, (action) => bindActionCreators(action, dispatch));
